import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import {
    Chart,
    BarSeries,
    ArgumentAxis,
    ValueAxis,
    LineSeries,
    ScatterSeries,
    Tooltip
} from '@devexpress/dx-react-chart-material-ui';

import { Animation, EventTracker } from '@devexpress/dx-react-chart';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { easeBounceOut } from 'd3-ease';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
//import { progressTimeStep } from '../../../Config/constants';
import { newDateToHHmm } from '../../../Helpers/dateHelper';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

export default function ProgressionChart(props) {
    const classes = useStyles();

    const [chartData, setChartData] = useState([])
    const [timeframe, setTimeframe] = useState(0)

    useEffect(() => {

        if (props.order) {
            dataService.getProgressByProductionOrderId(props.order.id).then((progress) => {
                let data = []
                var i;
                let progression = []
                if (timeframe === 0) {
                    progression = progress.progress1H
                }
                else if (timeframe === 1) {
                    progression = progress.progress30M
                }
                else (
                    progression = progress.progress15M
                )
                for (i = 0; i < progression.length; i++) {
                    data.push({ time: newDateToHHmm(new Date(progression[i].time)), value: progression[i].value, timeframe: progression[i].timeframe })
                }

                let amountToProcess = props.order.bomOut[0].quantityToProduce

                data.push({ time: "", value: amountToProcess })

                var j;
                for (j = 0; j < data.length - 1; j++) {
                    data[j]['milestoneAmount'] = (amountToProcess / (data.length - 2)) * i
                    if (j === data.length - 2) {
                        data[j]['endPoint'] = amountToProcess
                    }
                }

                if (JSON.stringify(data) !== JSON.stringify(chartData)) {
                    setChartData(data)
                }

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
    }, [props.fakeDataWorkstation, timeframe]);

    let numberOfSteps = props.progressions.find(x => x.workstationId === props.fakeDataWorkstation.id).progression.length

    const getPath = (x, width, y, y1) =>

        `M ${x} ${y1 - 0.5}
        L ${width + x} ${y1 - 0.5}
        L ${width + x} ${y + 8}
        q0,-8 -8,-8   
        L ${x + width - 8} ${y}
        L ${x + 8} ${y}
        q-8,0 -8,8 
        Z`;



    const BarWithLabel = ({
        arg, barWidth, maxBarWidth, val, startVal, color, value, style, argument
    }) => {
        const width = maxBarWidth * barWidth;
        return (chartData[chartData.length - 1].time !== argument ?
            <React.Fragment>
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="5%" stopColor={FlagstoneTheme.palette.primary.main} />
                        <stop offset="95%" stopColor="white" />
                    </linearGradient>
                </defs>
                <path d={getPath(arg - width / 2, width, val, startVal)} style={style} fill="url(#gradient)" />
            </React.Fragment> :
            <React.Fragment>
                <defs>
                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="5%" stopColor="rgb(1,1,1,0)" />
                        <stop offset="95%" stopColor="rgb(1,1,1,0)" />
                    </linearGradient>
                </defs>
                <path d={getPath(arg - width / 2, width, val, startVal)} style={style} fill="url(#gradient1)" />
            </React.Fragment>
        );
    };

    const changeTimeframe = (event) => {
        setTimeframe(event.target.value)
    }

    const lineComponent = (props) => {

        return (
            <React.Fragment>
                <LineSeries.Path {...props}
                    strokeDasharray="4,3"
                    color="black"
                >
                </LineSeries.Path>
            </React.Fragment>)
    }
  
    return (
        <div className={classes.progressionChart}>

            <div className={classes.header}>
                <div className={classes.title}>
                    Progression
                </div>
                <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    variant="outlined"
                    className={classes.select}
                    value={timeframe}
                    onChange={(e) => changeTimeframe(e)}
                >
                    <MenuItem value={0}>{"1H"}</MenuItem>
                    <MenuItem value={1}>{"30M"}</MenuItem>
                </Select>
            </div>
            {chartData.length > 0 && chartData[0].timeframe === timeframe && 
                <Chart className={classes.chart}
                    data={chartData}
                >
                    <ArgumentAxis />
                    <ValueAxis max={numberOfSteps} />
                    <BarSeries
                        name="barSeries"
                        valueField="value"
                        argumentField="time"
                        style={{ width: "3%" }}
                        pointComponent={BarWithLabel}
                    />
                    <EventTracker />
                    <Tooltip />
                    <ScatterSeries
                        valueField="endPoint"
                        argumentField="time"
                        color="black"
                    />
                    <LineSeries
                        name="progress"
                        valueField="milestoneAmount"
                        argumentField="time"
                        seriesComponent={lineComponent}
                    />

                    <Animation duration={2000} easing={easeBounceOut} />
                </Chart>}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    chart: {
        height: "400px !important",
        width: "100%",
    },
    title: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginBottom: "10px",
        float: "left"
    },
    header: {
        height: "40px"
    },
    chartLabel: {
        width: "50px",
        height: "20px",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        position: "relative",
        right: "2%"
    },
    progressionChart: {
        height: "425px",
        padding: "20px",
        backgroundColor: "white",
        borderRadius: "6px",
        marginBottom: "10px",
        paddingBottom: "40px",
        overflow: "hidden",
        paddingRight: "0px",
        borderRight: "40px solid white",

    },
    select: {
        height: "40px",
        width: "80px",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "15px",
        float: "right",
    },

}));